(() => {
  const root = document.querySelector('#evp-adv, #evp-adv2');
  const template = document.querySelector('#fortion-advertorial-card');
  if (!root || !template) return;
  const card = template.content.cloneNode(true);
  const initialDigits = root.querySelectorAll('.offer-x-timer > div > span:first-child');
  card.querySelectorAll('.fortion-ad-timer > div > span:first-child').forEach((digit, index) => {
    if (initialDigits[index]) digit.textContent = initialDigits[index].textContent;
  });

  if (root.id === 'evp-adv') {
    const sidebar = root.querySelector('aside');
    if (!sidebar) return;
    sidebar.classList.add('fortion-ad-sidebar');
    sidebar.parentElement.classList.add('fortion-ad-layout');
    sidebar.replaceChildren(card);
  } else {
    const start = root.querySelector('.hero');
    const end = root.querySelector('.footer');
    if (!start || !end || start.parentElement !== end.parentElement) return;
    const layout = document.createElement('div');
    layout.className = 'fortion-ad-layout';
    const content = document.createElement('div');
    content.className = 'fortion-ad-content';
    const sidebar = document.createElement('aside');
    sidebar.className = 'fortion-ad-sidebar';
    sidebar.setAttribute('aria-label', 'EvoPulse Pro availability');
    sidebar.append(card);
    start.before(layout);
    let section = start;
    while (section && section !== end) {
      const next = section.nextSibling;
      content.append(section);
      section = next;
    }
    layout.append(content, sidebar);
  }

  const availability = template.content.querySelector('.fortion-ad-button');
  if (!availability || document.querySelector('[data-fortion-sticky-ready]')) return;
  const floating = root.querySelector('#floatingCta') || availability.cloneNode(true);
  floating.id = 'floatingCta';
  floating.className = 'floating-cta fortion-ad-mobile-cta';
  floating.dataset.fortionStickyReady = 'true';
  floating.href = availability.href;
  floating.textContent = 'Check Availability';
  const arrow = document.createElement('span');
  arrow.textContent = '→';
  arrow.setAttribute('aria-hidden', 'true');
  floating.append(arrow);
  floating.hidden = true;
  if (!floating.isConnected) root.append(floating);
  const spacer = document.createElement('div');
  spacer.className = 'fortion-ad-mobile-spacer';
  spacer.setAttribute('aria-hidden', 'true');
  document.body.append(spacer);
  const mobile = window.matchMedia('(max-width: 1099px)');
  let pending = false;
  const updateFloating = () => {
    const visible = mobile.matches && window.scrollY >= 240;
    floating.hidden = !visible;
    floating.inert = !visible;
    floating.setAttribute('aria-hidden', String(!visible));
    floating.classList.toggle('visible', visible);
    pending = false;
  };
  window.addEventListener('scroll', () => {
    if (!pending) {
      pending = true;
      window.requestAnimationFrame(updateFloating);
    }
  }, { passive: true });
  mobile.addEventListener('change', updateFloating);
  window.addEventListener('pageshow', updateFloating);
  updateFloating();
})();
